// @ts-nocheck
(function () {
  function attachCarouselPointerDrag(track) {
    var dragId = null;
    var startX = 0;
    var startScroll = 0;
    function onDown(e) {
      if (e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
      if (e.button !== 0) return;
      dragId = e.pointerId;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      try {
        track.setPointerCapture(e.pointerId);
      } catch (_e) {}
      track.classList.add('cursor-grabbing');
    }
    function onMove(e) {
      if (dragId == null || e.pointerId !== dragId) return;
      track.scrollLeft = startScroll - (e.clientX - startX);
    }
    function onUp(e) {
      if (dragId == null || e.pointerId !== dragId) return;
      dragId = null;
      try {
        track.releasePointerCapture(e.pointerId);
      } catch (_e) {}
      track.classList.remove('cursor-grabbing');
    }
    track.addEventListener('pointerdown', onDown);
    track.addEventListener('pointermove', onMove);
    track.addEventListener('pointerup', onUp);
    track.addEventListener('pointercancel', onUp);
  }

  /**
   * Outfit hero carousel: same infinite-strip model as PDP (`product-capsule` initPdpGallery).
   * Triple strip; normalize only after scroll settles (280ms / scrollend), never mid-smooth-scroll.
   */
  function initLiveOutfitHeroCarousels(root) {
    if (!root) return;
    root.querySelectorAll('[data-live-outfit-hero-carousel]').forEach(function (carousel) {
      if (carousel.dataset.liveOutfitHeroInit === '1') return;
      carousel.dataset.liveOutfitHeroInit = '1';

      var track = carousel.querySelector('[data-live-outfit-hero-track]');
      var prevBtn = carousel.querySelector('[data-live-outfit-hero-prev]');
      var nextBtn = carousel.querySelector('[data-live-outfit-hero-next]');
      if (!track) return;

      var originals = Array.prototype.slice.call(track.querySelectorAll('[data-live-outfit-hero-slide]'));
      var realCount = originals.length;
      if (realCount < 2) return;

      var jumping = false;
      var loopSettleTimer = null;
      var resizeTimer = null;
      var timer = null;
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function slideWidth() {
        var el = originals.length ? originals[0] : null;
        if (el) {
          var ow = el.offsetWidth;
          if (ow > 0) return ow;
        }
        return track.clientWidth || 0;
      }

      function smoothBehavior() {
        return prefersReducedMotion ? 'auto' : 'smooth';
      }

      function logicalFromTrackIndex(i) {
        return ((i % realCount) + realCount) % realCount;
      }

      function jumpTo(left) {
        var prevBehavior = track.style.scrollBehavior;
        jumping = true;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = left;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            track.style.scrollBehavior = prevBehavior;
            jumping = false;
          });
        });
      }

      /** Map scroll to middle segment [realCount, 2*realCount-1] with invisible ±realCount jumps. */
      function normalizeSlideZone() {
        if (jumping) return;
        var w = slideWidth();
        if (!w) return;
        var idx = Math.round(track.scrollLeft / w);
        if (idx < realCount) {
          jumpTo(track.scrollLeft + realCount * w);
        } else if (idx >= 2 * realCount) {
          jumpTo(track.scrollLeft - realCount * w);
        }
      }

      function goBy(delta) {
        var w = slideWidth();
        if (!w) return;
        var prevSnap = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = Math.round(track.scrollLeft / w) * w;
        track.style.scrollBehavior = prevSnap;
        normalizeSlideZone();
        var i = Math.round(track.scrollLeft / w);
        var next = i + delta;
        var maxIdx = 3 * realCount - 1;
        if (next < 0) next = 0;
        if (next > maxIdx) next = maxIdx;
        track.scrollTo({ left: next * w, behavior: smoothBehavior() });
      }

      function setArrowState() {
        if (!prevBtn || !nextBtn) return;
        prevBtn.disabled = false;
        nextBtn.disabled = false;
      }

      function advanceAutoplay() {
        goBy(1);
      }

      var firstOriginal = originals[0];
      var leftFrag = document.createDocumentFragment();
      for (var li = 0; li < realCount; li++) {
        var ln = originals[li].cloneNode(true);
        ln.setAttribute('data-live-outfit-hero-clone', 'pre');
        ln.setAttribute('aria-hidden', 'true');
        leftFrag.appendChild(ln);
      }
      track.insertBefore(leftFrag, firstOriginal);

      for (var ri = 0; ri < realCount; ri++) {
        var rn = originals[ri].cloneNode(true);
        rn.setAttribute('data-live-outfit-hero-clone', 'post');
        rn.setAttribute('aria-hidden', 'true');
        track.appendChild(rn);
      }

      track.querySelectorAll('[data-live-outfit-hero-clone] img').forEach(function (img) {
        img.loading = 'eager';
      });

      jumping = true;
      var prevScrollBehavior = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = realCount * slideWidth();
      track.style.scrollBehavior = prevScrollBehavior;
      requestAnimationFrame(function () {
        jumping = false;
        setArrowState();
      });

      function onResize() {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
          var w = slideWidth();
          if (!w) return;
          var i = Math.round(track.scrollLeft / w);
          var logical = logicalFromTrackIndex(i);
          jumping = true;
          track.scrollLeft = (logical + realCount) * w;
          requestAnimationFrame(function () {
            jumping = false;
          });
          setArrowState();
        }, 150);
      }

      function settleInfiniteCarousel() {
        if (jumping) return;
        normalizeSlideZone();
        setArrowState();
      }

      attachCarouselPointerDrag(track);

      track.addEventListener(
        'scroll',
        function () {
          if (jumping) return;
          window.clearTimeout(loopSettleTimer);
          loopSettleTimer = window.setTimeout(function () {
            loopSettleTimer = null;
            settleInfiniteCarousel();
          }, 280);
        },
        { passive: true },
      );

      try {
        track.addEventListener(
          'scrollend',
          function () {
            if (jumping) return;
            window.clearTimeout(loopSettleTimer);
            loopSettleTimer = null;
            settleInfiniteCarousel();
          },
          { passive: true },
        );
      } catch (_e) {}

      window.addEventListener('resize', onResize);

      if (prevBtn) prevBtn.addEventListener('click', function () { goBy(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goBy(1); });

      setArrowState();

      function startAutoplay() {
        if (prefersReducedMotion) return;
        stopAutoplay();
        timer = window.setInterval(function () {
          advanceAutoplay();
        }, 5000);
      }

      function stopAutoplay() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('mouseleave', function () {
        if (carousel.dataset.liveOutfitHeroVisible === '1') startAutoplay();
      });
      carousel.addEventListener('focusin', stopAutoplay);
      carousel.addEventListener('focusout', function () {
        if (carousel.dataset.liveOutfitHeroVisible === '1') startAutoplay();
      });

      if (typeof IntersectionObserver !== 'undefined') {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var on = entry.isIntersecting && entry.intersectionRatio > 0;
              carousel.dataset.liveOutfitHeroVisible = on ? '1' : '0';
              if (on) startAutoplay();
              else stopAutoplay();
            });
          },
          { threshold: 0.01, rootMargin: '0px' },
        );
        io.observe(carousel);
      } else {
        carousel.dataset.liveOutfitHeroVisible = '1';
        startAutoplay();
      }
    });
  }

  function init(root) {
    var panels = root.querySelectorAll('[data-outfit-panel]');
    var links = root.querySelectorAll('[data-outfit-link]');
    var defaultHandle = root.getAttribute('data-default-outfit') || '';
    var rafPending = false;

    function setStickyVisible(sticky, visible) {
      sticky.classList.toggle('translate-y-full', !visible);
      sticky.classList.toggle('translate-y-0', visible);
      sticky.classList.toggle('opacity-0', !visible);
      sticky.classList.toggle('opacity-100', visible);
      sticky.classList.toggle('pointer-events-none', !visible);
      sticky.classList.toggle('pointer-events-auto', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    function syncNavDesktopCtas() {
      var host = root.querySelector('[data-outfit-nav-desktop-cta-host]');
      if (!host) return;

      function hideAllNavCtas() {
        host.querySelectorAll('[data-outfit-nav-cta-for]').forEach(function (el) {
          el.classList.add('hidden');
        });
      }

      var desktop = window.matchMedia('(min-width: 1024px)').matches;
      if (!desktop) {
        hideAllNavCtas();
        return;
      }

      var visiblePanel = null;
      root.querySelectorAll('[data-outfit-panel]').forEach(function (p) {
        if (!p.hidden) visiblePanel = p;
      });

      if (!visiblePanel) {
        hideAllNavCtas();
        return;
      }

      var handle = (visiblePanel.getAttribute('data-outfit-panel') || '').trim();
      var anchor = visiblePanel.querySelector('[data-outfit-cta-anchor]');
      var navCta = host.querySelector('[data-outfit-nav-cta-for="' + handle + '"]');

      if (!navCta || !anchor) {
        hideAllNavCtas();
        return;
      }

      host.querySelectorAll('[data-outfit-nav-cta-for]').forEach(function (el) {
        if (el !== navCta) {
          el.classList.add('hidden');
          return;
        }
        var past = anchor.getBoundingClientRect().bottom < 8;
        el.classList.toggle('hidden', !past);
      });
    }

    function syncStickies() {
      var desktop = window.matchMedia('(min-width: 1024px)').matches;
      root.querySelectorAll('[data-outfit-panel]').forEach(function (panel) {
        var sticky = panel.querySelector('[data-outfit-sticky-cta]');
        var anchor = panel.querySelector('[data-outfit-cta-anchor]');
        if (!sticky || !anchor) return;
        if (panel.hidden) {
          setStickyVisible(sticky, false);
          return;
        }
        if (desktop) {
          setStickyVisible(sticky, false);
          return;
        }
        var r = anchor.getBoundingClientRect();
        setStickyVisible(sticky, r.bottom < 8);
      });
    }

    function scheduleSyncStickies() {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(function () {
        rafPending = false;
        syncStickies();
        syncNavDesktopCtas();
      });
    }
    if (defaultHandle) {
      // trim — Liquid can leave stray whitespace in attributes in edge cases
      defaultHandle = defaultHandle.trim();
    }

    function validHandle(h) {
      if (!h) return false;
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].getAttribute('data-outfit-panel') === h) return true;
      }
      return false;
    }

    if (!validHandle(defaultHandle) && panels.length > 0) {
      defaultHandle = panels[0].getAttribute('data-outfit-panel') || '';
    }
    if (!validHandle(defaultHandle) && links.length > 0) {
      defaultHandle = links[0].getAttribute('data-outfit-link') || '';
    }

    function show(handle) {
      var h = handle;
      if (!validHandle(h)) h = defaultHandle;
      if (!validHandle(h)) h = '';

      for (var j = 0; j < panels.length; j++) {
        var p = panels[j];
        var ph = p.getAttribute('data-outfit-panel');
        p.hidden = !h || ph !== h;
      }

      links.forEach(function (a) {
        var lh = a.getAttribute('data-outfit-link');
        var active = !!h && lh === h;
        a.setAttribute('aria-current', active ? 'page' : 'false');
        a.classList.toggle('text-foreground', active);
        a.classList.toggle('font-medium', active);
        a.classList.toggle('text-muted', !active);
        a.classList.toggle('font-normal', !active);
      });
      syncStickies();
      syncNavDesktopCtas();
    }

    var param = new URLSearchParams(window.location.search).get('outfit');
    var initial = validHandle(param) ? param : defaultHandle;
    if (!validHandle(param) && validHandle(defaultHandle)) {
      var url = new URL(window.location.href);
      url.searchParams.set('outfit', defaultHandle);
      window.history.replaceState({}, '', url.toString());
    }
    show(initial);
    initLiveOutfitHeroCarousels(root);

    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var hh = a.getAttribute('data-outfit-link') || '';
        var url = new URL(window.location.href);
        url.searchParams.set('outfit', hh);
        window.history.replaceState({}, '', url.toString());
        show(hh);
      });
    });

    window.addEventListener('popstate', function () {
      var p = new URLSearchParams(window.location.search).get('outfit');
      show(validHandle(p) ? p : defaultHandle);
    });

    window.addEventListener('scroll', scheduleSyncStickies, { passive: true });
    window.addEventListener('resize', scheduleSyncStickies);
    scheduleSyncStickies();
  }

  document.querySelectorAll('[data-collection-live-outfits]').forEach(function (el) {
    init(el);
  });
})();
